import React  from "react";
import HolidayTab from "./components/HolidayTab";
import SummaryHeader from "components/header/SummaryHeader";

const Holidays = () => {
	
	return (
	    <div>
			<SummaryHeader
				title={"Holidays"}
				iconName="Calendar1"
				description={"View and manage all holidays"}
				color={"blue"}
			/>
			<div className="mt-5 grid h-full grid-cols-1 gap-4">      		
				<HolidayTab />
			</div>
	    </div>
    );
};

export default Holidays;